import { render } from "./CustomerNewView.vue?vue&type=template&id=9734879c"
import script from "./CustomerNewView.vue?vue&type=script&lang=js"
export * from "./CustomerNewView.vue?vue&type=script&lang=js"

import "./CustomerNewView.vue?vue&type=style&index=0&id=9734879c&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__